import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import DateField from "@/components/DateField";
import ParentProjectPicker from "./ParentProjectPicker";

/** VO fields for EditProjectDialog. Parent project details are read-only shown at top. */
export default function EditVOFields({ project, form, setForm, canChangeParent }) {
  return (
    <>
      <ParentProjectPicker
        project={project}
        value={form.parent_project_id}
        onChange={(id) => setForm({ ...form, parent_project_id: id })}
        disabled={!canChangeParent}
      />
      <div className="space-y-1.5">
        <Label className="overline text-slate-600">Variation Order Name</Label>
        <Input data-testid="edit-vo-name" required value={form.variation_order_name} onChange={(e) => setForm({ ...form, variation_order_name: e.target.value })} className="rounded-none" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">VO Contract Issue Date</Label>
          <DateField testid="edit-vo-start" value={form.vo_start_date} onChange={(v) => setForm({ ...form, vo_start_date: v })} />
        </div>
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">VO End Date</Label>
          <DateField testid="edit-vo-end" value={form.vo_end_date} onChange={(v) => setForm({ ...form, vo_end_date: v })} />
        </div>
      </div>
    </>
  );
}
